import {Component, OnInit} from '@angular/core';
import {AppComponent} from "../app.component";
import {Router} from "@angular/router";
import {AcessoService} from "../acesso/acesso.service";

@Component({
    selector: 'app-admin',
    templateUrl: './admin.component.html',
    styleUrls: ['./admin.component.css'],
    providers: [AcessoService]
})
export class AdminComponent extends AppComponent implements OnInit {

    aplicacao: AppComponent;

    ngOnInit() {
        if(!this.isAdmin()){
            this.router.navigateByUrl('acesso');
        }
    }

}



// WEBPACK FOOTER //
// ./src/app/admin/admin.component.ts